import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useHistory } from 'react-router';
import { Dropdown, Menu } from 'antd';
import { userInfoVar } from 'src/apollo/cache';

const DropDownGlobalStyle = createGlobalStyle`
  /* overlay 루트에 붙는 class */
  .custom-dd {
    .ant-dropdown-menu {
      padding: 0 !important;
    }

    .ant-dropdown-menu-item,
    .ant-dropdown-menu-submenu-title {
      padding: 0 !important;
      /* 필요하면 높이/정렬까지 통일 */
      line-height: 25px;
    }
  }
`;

const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  background-color: #E0AC53;
  align-items: center;
  padding: 0 15px;
`;

const MenuDropdown = styled.div`
  background-color: #F0DC65;
  height: 28px;
  width: 100px;
  border-radius: 8px;
  font-size: 13px;
  color:#666566;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('/images/LevelUp/mobileHeaderTriangle.png');
  background-repeat: no-repeat;
  background-size: 10px 9px;
  background-position: right 5px center;
`;

const MenuBtn = styled.div`
  background-color: #666566;
  height: 25px;
  width: 100px;
  font-size: 12px;
  color: ${(props) => (props.isActive ? '#fff' : '#F0DC65')};
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileID = styled.span`
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  line-height: 100%;
  color: #666566;
`;

export default function LevelUpLibraryMobileHeader({ currentMenu, student_idx }) {
  const history = useHistory();
  const id = userInfoVar()?.view_id || userInfoVar()?.id;

  const items = [
    {
      current: 'bookshelf',
      name: 'Bookshelf',
      path: '/level-up',
      key: '0',
    },
    {
      current: 'favorite',
      name: 'Favorite',
      path: '/level-up/favorite',
      key: '1',
    },
    {
      current: 'in_progress',
      name: 'In Progress',
      path: '/level-up/inprogress',
      key: '2',
    },
    {
      current: 'portfolio',
      name: 'Portfolio',
      path: `/level-up/portfolio${student_idx ? `?student_idx=${student_idx}` : ''}`,
      key: '3',
    },
    {
      current: 'calendar',
      name: 'Calendar',
      path: `/level-up/calendar${student_idx ? `?student_idx=${student_idx}` : ''}`,
      key: '4',
    },
  ];

  const currentName = items.find((e) => e.current === currentMenu)?.name || '';

  // ✅ antd v4 방식: overlay는 Menu 컴포넌트로
  const overlayMenu = (
    <Menu>
      {items.map((it) => (
        <Menu.Item key={it.key} style={{ padding: 0, margin:'0 auto' }}>
          <MenuBtn
            isActive={currentMenu === it.current}
            onClick={() =>currentMenu !== it.current&& history.push(it.path)}
          >
            {it.name}
          </MenuBtn>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <>
      <DropDownGlobalStyle />
      <RowFlex>
        <Dropdown
          overlay={overlayMenu}
          overlayClassName="custom-dd"
          trigger={['click']}
        >
          <MenuDropdown>{currentName}</MenuDropdown>
        </Dropdown>

        <MobileID>
          <span>ID</span> {id}
        </MobileID>
      </RowFlex>
    </>
  );
}
